import React from "react";
import Loader from "../../../components/common/Loader";
import { checkEmptyOrNull } from "../../../components/Utils";

const MembersTable = ({ members, loading, error, onRetry, categoryName }) => {
  if (loading) {
    return (
      <div className="p-3">
        <table className="table itable table-sm m-0">
          <tbody>
            <Loader loading={loading} colspan="4" />
          </tbody>
        </table>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger d-flex align-items-center justify-content-between m-3 p-2 px-3">
        <div className="d-flex align-items-center gap-2">
          <i className="fa-solid fa-triangle-exclamation"></i>
          <span>{error}</span>
        </div>
        {onRetry && (
          <button
            type="button"
            className="btn btn-sm btn-outline-danger"
            onClick={onRetry}
          >
            Retry
          </button>
        )}
      </div>
    );
  }

  if (!members || members.length === 0) {
    return (
      <div className="text-center py-3 text-muted">
        <span>No members found for this role/category.</span>
      </div>
    );
  }

  return (
    <div className="table-responsive p-3 bg-light border-top">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong className="text-dark">
          <i className="fa-solid fa-users text-primary me-2"></i>
          {categoryName} - Members ({members.length})
        </strong>
      </div>
      <table className="table table-bordered table-striped itable table-sm bg-white m-0">
        <thead>
          <tr>
            <th style={{ width: "60px" }}>Sl. No.</th>
            <th>Member</th>
            <th>Role</th>
            <th className="text-center">Status</th>
          </tr>
        </thead>
        <tbody className="table-border-bottom-0">
          {members.map((member, index) => {
            const isActive = Number(member.membership_status) === 1;

            return (
              <tr key={member.member_id || index}>
                <td>{index + 1}</td>
                <td>
                  <strong>{member.name}</strong>
                </td>
                <td>{checkEmptyOrNull(member.role)}</td>
                <td className="text-center">
                  <span
                    className={`badge ${isActive ? "bg-success" : "bg-danger"}`}
                  >
                    {isActive ? "Active" : "Inactive"}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default MembersTable;
